// extracted by mini-css-extract-plugin
export default {"container":"urb_1Zn0C","inner":"urb_inn_2Aidp","logo":"urb_log_1-v2h","logoContainer":"urb_log_3IEHv","shadow":"urb_sha_1non8"};